import $ from 'jquery';

$(function () {
  var clickHandler = function () {
    $(document).on('hidden.bs.modal', function () {
      window.setTimeout(function () {
        // need timeout to allow time for secret file download to start
        window.location.reload();
      }, 500);
    });
  };

  $('.js-data-return-modal-open').on('click', clickHandler);
});
